import { render, staticRenderFns } from "./BoxSettingsTable.vue?vue&type=template&id=a45ddcae"
import script from "./BoxSettingsTable.vue?vue&type=script&lang=js"
export * from "./BoxSettingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports